import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import isbot from 'isbot';
import { WpImage } from '@streamamg/wordpress-lib';
import { ThumbnailFlavors } from '@streamamg/stream-play-lib';
import { ImageUtils } from './image.utils';

export interface ImageSize {
  width: number;
  height?: number;
  url: string;
}

@Component({
  selector: 'amg-image',
  templateUrl: './image.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageComponent implements OnChanges {
  /**
   * Default image
   */
  @Input() lazyLoadDefaultImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
  @Input() cssClass: string;
  @Input() title: string;
  @Input() alt: string;

  /**
   * background-position: https://www.w3schools.com/cssref/pr_background-position.asp
   */
  @Input() position: string;
  @Input() mode: 'div' | 'img' = 'img';

  /**
   * Accept single url string or an array of ImageSize for responsive images
   */
  @Input() src: string | ImageSize[];
  @Input() srcWp: WpImage;
  @Input() srcSp: ThumbnailFlavors;

  /**
   * sizes attribute https://developer.mozilla.org/en-US/docs/Learn/HTML/Multimedia_and_embedding/Responsive_images
   */
  @Input() sizes: string;

  /**
   * disable the lazy loading
   */
  @Input() noLazyLoad: boolean;
  public isBot: boolean;
  public isResponsive: boolean;
  public showImg: boolean;
  public srcList: string;
  public srcSingle: string;

  constructor() {

    this.title = '';
    this.alt = '';
    this.isBot = isbot(navigator.userAgent);
  }

  ngOnChanges(): void {

    if (this.srcWp) {

      this.src = ImageUtils.getWpSrcSet(this.srcWp);

    } else if (this.srcSp) {

      this.src = ImageUtils.getSpSrcSet(this.srcSp);
    }

    this.isResponsive = typeof this.src !== 'string' && this.src !== undefined;
    const sizes: ImageSize[] = this.src as ImageSize[];

    if (this.isResponsive && sizes?.length > 0) {

      this.srcList = sizes.map(size => `${size.url} ${size.width}w`).join(', ');
      this.srcSingle = sizes[0].url;

    } else {

      this.srcList = this.srcSingle = this.src as string;
    }
  }
}
